import { BASE_API } from 'commons/constants/env'
import { createClient } from './config/client'

const BaseApi = createClient(BASE_API)

export { BaseApi }
